import { AxiosPromise } from 'axios';

import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { RecepcionActividad } from '@/pantallas/Recepcion/RecepcionActividad';

type HttpRequestBody = {
  clienteProveedorId: number;
  proveedorId: number;
  usuario: string;
  password: string;
  fechaIni: string;
  fechaFin: string;
  tiempoMinimo: number;
  cantidadBloque: number;
  estado: number;
  flotas: number[];
  etiquetas: number[];
  vehiculos: number[];
};

const axios = new AxiosVue(ServicioProxy.Integracion);
const makeHttpRequest = (
  recepcionActividad: CreacionRecepcionActividad
): AxiosPromise<unknown> => {
  const body: HttpRequestBody = {
    clienteProveedorId: recepcionActividad.clienteProveedor.id,
    proveedorId: recepcionActividad.proveedor.id,
    usuario: recepcionActividad.login,
    password: recepcionActividad.password,
    fechaIni: recepcionActividad.fechaInicio.format(),
    fechaFin: recepcionActividad.fechaTermino
      ? recepcionActividad.fechaTermino.format()
      : null,
    tiempoMinimo: recepcionActividad.intervaloTransmiciones,
    cantidadBloque: recepcionActividad.numeroRegistrosPorBloque,
    estado: recepcionActividad.estado.id,
    flotas: recepcionActividad.flotasId,
    etiquetas: recepcionActividad.etiquetasId,
    vehiculos: recepcionActividad.vehiculosId,
  };
  return axios.http.post(`integracion/recepciones`, body);
};

export interface CreacionRecepcionActividad
  extends Pick<RecepcionActividad, Exclude<keyof RecepcionActividad, 'id'>> {
  flotasId: number[];
  etiquetasId: number[];
  vehiculosId: number[];
}

export const crearRecepcionActividad = (
  recepcionActividad: CreacionRecepcionActividad
) => makeHttpRequest(recepcionActividad);
